import React from "react";

import { DISPLAYTYPE, getDisplayType } from "helpers/Compare";
import { FiArrowRight, FiMinus, FiPlus } from "react-icons/fi";

function DiffIcon({ type }) {
  const displayType = getDisplayType(type);
  if (displayType === DISPLAYTYPE.ADD)
    return <FiPlus className="text-green-500" />;
  if (displayType === DISPLAYTYPE.REMOVE)
    return <FiMinus className="text-red-500" />;
  if (displayType === DISPLAYTYPE.CHANGE)
    return <FiArrowRight className="text-orange-500" />;
  return null;
}

export default DiffIcon;
